import { render, staticRenderFns } from "./UserProfileDev.vue?vue&type=template&id=6467e35d&scoped=true&"
import script from "./UserProfileDev.vue?vue&type=script&lang=js&"
export * from "./UserProfileDev.vue?vue&type=script&lang=js&"
import style0 from "./UserProfileDev.vue?vue&type=style&index=0&id=6467e35d&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6467e35d",
  null
  
)

export default component.exports